import React from 'react'
import S from './styled'
import CreateRootForm from './createRootForm'

const LoginPage = () => (
  <S.LoginContainer>
    <CreateRootForm />
  </S.LoginContainer>
)

export default LoginPage
